import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import imagePath from "../../assets/zupee-icon.svg";
import { NAVIGATION_ROUTES } from "../../constant";
import useSplash from "../../pages/SplashScreen/useSplash";

const SplashScreen: React.FC = () => {
  const navigate = useNavigate();
  const { goToNextScreenPostSplash } = useSplash();

  useEffect(() => {
    const timer = setTimeout(() => {
      // navigate(NAVIGATION_ROUTES.SIGNIN, { replace: true });
      goToNextScreenPostSplash();
    }, 1000);
    return () => clearTimeout(timer);
  }, [goToNextScreenPostSplash, navigate]);

  return (
    <>
      <div className={styles.splashContainer}>
        <div className={styles.logo}>
          <img
            src={imagePath}
            alt="zupee logo"
            width="100%"
            height="100%"
            loading="lazy"
          />
        </div>
      </div>
    </>
  );
};

export default SplashScreen;
